import storage from '@/utils/localStorage'
import axios from '@/axios'
export default {
  namespaced: true,
  state: {
    token: '',
    menu: JSON.parse(localStorage.getItem('menu') || '[]'),
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}') // 用户信息（登录、注册获取）
  },
  getters: {
    userInfo: (state) => {
      return state.userInfo && state.userInfo.token ? state.userInfo : storage.getItem('userInfo') || {}
    },
    token: (state) => state.token || storage.getItem('token') || state.userInfo.token || storage.getItem('userInfo').token || '',
    getAllMenuCodes: (state) => {
      const extractCodes = (menuItems) => {
        if (!menuItems || !Array.isArray(menuItems)) return []

        return menuItems.reduce((codes, item) => {
          if (item.code) {
            codes.push(item.code)
          }
          if (item.children && Array.isArray(item.children)) {
            codes.push(...extractCodes(item.children))
          }
          return codes
        }, [])
      }

      return extractCodes(state.menu)
    }
  },
  mutations: {
    updateUserInfo(state, result) {
      if (!result) {
        state.token = ''
        state.userInfo = {}
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        return
      }
      storage.setItem('token', result.token == null ? 'defaulttoken' : result.token)
      storage.setItem('userInfo', result)
      state.token = result.token
      state.userInfo = result
    },
    updateMenu(state, result) {
      localStorage.setItem('menu', JSON.stringify(result))
      state.menu = result
    }
  },
  actions: {
    async post({ commit }, { url, data }) {
      const res = await axios.post(url, data)
      return res
    },
    async getMenus({ dispatch, commit }) {
      const { data } = await dispatch('post', { url: '/api/sys/menu/user/menus' })
      console.log('获取到的菜单', data)

      if (data instanceof Array) commit('updateMenu', data)
      return data instanceof Array
    }
  }
}
